import { WebPlugin } from '@capacitor/core';
export class MotionWeb extends WebPlugin {
    constructor() {
        super();
        this.registerWindowListener('devicemotion', 'accel');
        this.registerWindowListener('deviceorientation', 'orientation');
    }
}
//# sourceMappingURL=web.js.map